var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4739)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1401 28.8201C25.7301 28.8201 25.3901 28.4801 25.3901 28.0701V26.11C25.3901 23.18 27.7701 20.8 30.7101 20.8H32.6701C33.0801 20.8 33.4201 21.14 33.4201 21.55C33.4201 21.96 33.0801 22.3 32.6701 22.3H30.7101C28.6101 22.3 26.8901 24.01 26.8901 26.11V28.0701C26.8901 28.4901 26.5501 28.8201 26.1401 28.8201Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1401 31.0001C25.7301 31.0001 25.3901 30.6601 25.3901 30.2501V26.1201C25.3901 24.0201 23.6801 22.3101 21.5801 22.3101H19.6201C19.2101 22.3101 18.8701 21.9701 18.8701 21.5601C18.8701 21.1501 19.2101 20.8101 19.6201 20.8101H21.5801C24.5101 20.8101 26.8901 23.1901 26.8901 26.1201V30.2501C26.8901 30.6601 26.5501 31.0001 26.1401 31.0001Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1398 24.0999C20.9498 24.0999 20.7598 24.0299 20.6098 23.8799L18.8098 22.0799C18.5198 21.7899 18.5198 21.3099 18.8098 21.0199L20.6098 19.2199C20.8998 18.9299 21.3798 18.9299 21.6698 19.2199C21.9598 19.5099 21.9598 19.9899 21.6698 20.2799L20.3998 21.5499L21.6698 22.8199C21.9598 23.1099 21.9598 23.5899 21.6698 23.8799C21.5198 24.0299 21.3298 24.0999 21.1398 24.0999Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8598 24.0999C30.6698 24.0999 30.4798 24.0299 30.3298 23.8799C30.0398 23.5899 30.0398 23.1099 30.3298 22.8199L31.5998 21.5499L30.3298 20.2799C30.0398 19.9899 30.0398 19.5099 30.3298 19.2199C30.6198 18.9299 31.0998 18.9299 31.3898 19.2199L33.1898 21.0199C33.4798 21.3099 33.4798 21.7899 33.1898 22.0799L31.3898 23.8799C31.2498 24.0299 31.0498 24.0999 30.8598 24.0999Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 35.75H23C17.57 35.75 15.25 33.43 15.25 28V22C15.25 16.57 17.57 14.25 23 14.25H29C34.43 14.25 36.75 16.57 36.75 22V28C36.75 33.43 34.43 35.75 29 35.75ZM23 15.75C18.39 15.75 16.75 17.39 16.75 22V28C16.75 32.61 18.39 34.25 23 34.25H29C33.61 34.25 35.25 32.61 35.25 28V22C35.25 17.39 33.61 15.75 29 15.75H23Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4739",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4739",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOo);
export default __webpack_public_path__ + "static/media/oo.67e8c5ffc5e526e9fe6149c6c86d410e.svg";
export { ForwardRef as ReactComponent };